<!-- src\components\MainMenu.vue -->
<template>
  <div v-if="showImage" class="image-container">
    <img class="preload-image" src="../assets/preload-image.jpg" />
    <button class="enter-button" @click="enterPlatform">进入实训平台</button>
  </div>
  <div v-else>
    <div class="page flex-col">
      <transition name="fade">
        <div class="loading-screen" v-if="!loaded" key="loading-screen">
          <h1>程序努力加载中...</h1>
        </div>
      </transition>
      <transition name="fade">
        <div class="main flex-col" v-if="loaded" key="main-content">
          <img class="title_shadow" referrerpolicy="no-referrer"
            src="../assets/img/MasterDDSSlicePNG06747c9279f5e4f8fc81c80a08134a36.png" />
          <span class="footer">广西壮族自治区气象培训中心</span>
          <div class="button-wrapper flex-col">
            <div class="button_top flex-col" @click="enterTour">
            <!-- <div class="button_top flex-col" @click="$router.push('/tourscene')"> -->
              <span class="button_text">自动气象站漫游</span>
            </div>
            <div class="button flex-col" @click="$router.push('/maintain-info')">
              <span class="button_text">维护维修知识</span>
            </div>
            <div class="button flex-col" @click="handleClick">
              <span class="button_text">互动答题系统</span>
            </div>
            <div class="button flex-col" @click="navigateTo('/aboutus')">
              <span class="button_text">关于程序</span>
            </div>
          </div>
          <img class="title" referrerpolicy="no-referrer"
            src="../assets/img/MasterDDSSlicePNG6ebe3d1fbe8707463ec580c2daa21077.png" />
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import '../assets/flexible.js';
export default {
  data() {
    return {
      loaded: false,
      images: [
        require('../assets/img/MasterDDSSlicePNG6ebe3d1fbe8707463ec580c2daa21077.png'),
        require('../assets/img/MasterDDSSlicePNG06747c9279f5e4f8fc81c80a08134a36.png'),
        require('../assets/img/MasterDDSSlicePNGe4d93d0ed3915930e4fa3507b05af898.jpg'),
        require('../assets/img/MasterDDSSlicePNG28581d5785022caae57812c0eb6acc7a.png'),
        require('../assets/img/MasterDDSSlicePNGae05053cabc4602940287f57b02898bf.png'),
        // 添加其他需要预加载的图片路径
      ],
      showImage: true,
    };
  },
  mounted() {
    this.preloadImages().then(() => {
      this.loaded = true;
      //   // 另一种 resize 调用方法
      //   this.$nextTick(() => {
      //   window.dispatchEvent(new Event('resize'));
      // });
    });
    if (localStorage.getItem('imageShown')) {
      this.showImage = false;
    }
    // 当组件被挂载（插入到 DOM）时，将 body 的背景颜色设置为黑色。
    document.body.style.backgroundColor = 'black';
    // 当组件被挂载（插入到 DOM）时，将 body 的 overflow 属性设置为 hidden。
    document.body.style.overflow = 'hidden';

    // 获取并检查 'imageShown' 的值
    const imageShown = this.getItemWithExpiry('imageShown');
    if (imageShown) {
      this.showImage = false;
    }
  },
  // 在路由改变之前，将 body 的背景颜色重置为空字符串（这将恢复 body 的默认背景颜色）。
  beforeRouteLeave(to, from, next) {
    document.body.style.backgroundColor = '';
    setTimeout(() => {
      document.body.style.overflow = 'auto';
    }, 3000);
    next();
  },
  beforeDestroy() {
    // 当组件被销毁之前，将 body 的 overflow 属性重置为 auto。
    document.body.style.overflow = 'auto';
  },
  methods: {
    preloadImages() {
      const promises = this.images.map((img) => {
        return new Promise((resolve, reject) => {
          const image = new Image();
          image.src = img;
          image.onload = () => {
            console.log(`Image loaded: ${img}`);
            resolve();
          };
          image.onerror = (error) => {
            console.error(`Failed to load image: ${img}`);
            reject(error);
          };
        });
      });
      return Promise.all(promises);
    },
    // 另一种跳转方法，可删除
    navigateTo(path) {
      setTimeout(() => {
        this.$router.push(path);
      }, 500);  // 延迟 500 毫秒（即0.5秒）再执行跳转操作
    },
    handleClick() {
      setTimeout(() => {
        // 在当前页打开链接
        // window.location.href = 'https://jinfeng.li/zdz_quiz/';
        // 在新标签页中打开链接
        window.open('https://jinfeng.li/zdz_quiz/', '_blank');
      }, 500);
    },
    hideImage() {
      this.showImage = false;
      // localStorage.setItem('imageShown', 'true');
      this.setItemWithExpiry('imageShown', 'true', 60000);
    },
    setItemWithExpiry(key, value, ttl) {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(key, JSON.stringify(item));
    },
    getItemWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return item.value;
    },
    created() {
      const imageShown = this.getItemWithExpiry('imageShown');
      if (imageShown) {
        this.showImage = false;
      }
    },
    toggleFullscreen() {
      if (!document.fullscreenElement &&    // alternative standard method
        !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {  // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen();
        }
      }
      // 如果已经处于全屏状态，就不做任何操作
    },
    enterPlatform() {
      this.hideImage();
      this.toggleFullscreen();
    },
    enterTour(){
      this.$router.push('/tourscene'); // 执行路由跳转
      this.toggleFullscreen(); // 执行全屏切换方法
    },
  },
};

// 在页面加载完成后触发一个 resize 事件，这会强制浏览器重新计算页面布局。
window.onload = function () {
  window.dispatchEvent(new Event('resize'));
};
// 禁止右键
window.onload = function () {
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
  });
};
</script>
<style scoped lang="css" src="../assets/index.rem-MainMenu.css" />
<style scoped>
/* fade效果，如果这里没定义，默认的过渡时间会更长一点 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.image-container {
  position: relative;
}

.preload-image {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

@keyframes color-change {
  0% {
    color: greenyellow;
  }

  50% {
    color: deepskyblue;
  }

  100% {
    color: greenyellow;
  }
}

.enter-button {
  border-radius: 10px;
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  font-size: 1.5rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  border: 0.125rem solid transparent;
  cursor: pointer;
  animation: color-change 2s infinite;
}

.enter-button:hover {
  border-color: deepskyblue;
}
</style>